module.exports = __webpack_public_path__ + "img/movieInterest.064b21e8.svg";